/**
 * Порядок задач в столбце по системному статусу (режим «проект для каждого
 * столбца»): в работе, на контроле, запланированное, в конце — завершённое.
 *
 * Внутри одного статуса остаётся ручной порядок столбца — сортировка
 * стабильная. Задача без статуса уходит в конец, а не теряется.
 */

import { OapStatusCode } from "@taskflow/contracts";

const RANK: Record<string, number> = {
  [OapStatusCode.IN_PROGRESS]: 0,
  [OapStatusCode.ON_CONTROL]: 1,
  [OapStatusCode.PLANNED]: 2,
  [OapStatusCode.COMPLETED]: 3,
};

const UNKNOWN = Object.keys(RANK).length;

export function sortByStatus<T extends { statusTag?: { code: string } | null }>(tasks: T[]): T[] {
  const rank = (task: T) => RANK[task.statusTag?.code ?? ""] ?? UNKNOWN;
  return [...tasks].sort((a, b) => rank(a) - rank(b));
}
